module.exports = __webpack_public_path__ + "static/media/5.4ace3813.png";